<template>
  <div class="modelling-controls">
    <el-button
      :loading="saving"
      class="r-button main"
      type="primary"
      @click="startCalc"
    >
      Запустить расчет
    </el-button>
  </div>
</template>

<script>
export default {
  props: ["saving"],
  methods: {
    startCalc() {
      this.$emit("start-calc");
    }
  }
};
</script>

<style lang="scss">
.modelling-controls {
  display: flex;
  justify-content: center;
  padding: 10px;

  .el-button {
    display: block;
    width: 50%;
    text-transform: uppercase;
  }
}
</style>
